// 45R: Hide console messages in production environment
// Note: console.error is preserved to ensure cart/form error handling works correctly

// Skip in Shopify Customizer — preserve console for debugging in design mode
if (window.Shopify && window.Shopify.designMode) {
  // Do not override console methods in the customizer
} else if ((function () {
  // Escape hatch: ?_45rdebug=1 keeps the console readable in production.
  try {
    return new URL(window.location.href).searchParams.get('_45rdebug') === '1';
  } catch (e) {
    return false;
  }
})()) {
  // Debug mode: keep native console methods intact.
} else if (!window.location.hostname.includes('127.0.0.1') &&
           !window.location.hostname.includes('localhost')) {

  console.log = function() {};
  console.warn = function() {};
  // console.error is intentionally NOT overridden
  // Horizon's product-form.js relies on console.error in .catch() handlers
}